import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-waiting-payment-dialog',
    imports: [MatProgressSpinnerModule, MatButtonModule, CommonModule],
    standalone: true,
   template: `
    <div style="text-align:center;padding:32px;max-width:380px;">
      <mat-spinner style="display: inline-block;"></mat-spinner>
      <h2 style="margin-top:24px;">{{data.title}}</h2>
      <h3 style="margin-top:24px;">{{data.message}}</h3>
      <ng-container *ngIf="data.pixQRCode">
        <div style="margin:24px 0;">
          <img [src]="'data:image/png;base64,' + data.pixQRCode" alt="QRCode Pix" style="width:200px;height:200px;box-shadow:0 2px 16px #0002;border-radius:8px;">
        </div>
        <div style="margin:16px 0 8px 0;font-weight:bold;">Copia e cola Pix:</div>
        <div style="background:#f4f4f4;padding:10px 8px;border-radius:8px;word-break:break-all;font-family:monospace;font-size:15px;">
          {{data.pixCopyPaste}}
        </div>
        <button mat-flat-button color="primary" style="margin-top:14px;" (click)="copyPix()">
          Copiar código
        </button>
        <div *ngIf="copied" style="color:green;margin-top:6px;">Código copiado!</div>
      </ng-container>
    </div>
  `
})
export class WaitingPaymentDialogComponent {
  copied = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  copyPix() {
    if (this.data.pixCopyPaste) {
      navigator.clipboard.writeText(this.data.pixCopyPaste);
      this.copied = true;
      setTimeout(() => this.copied = false, 1600);
    }
  }
}